import { Component, Input } from '@angular/core';
import { ContextualActionComponent } from './contextual-action.component';


@Component({
  moduleId: module.id,
  selector: 'export-review-action',
  templateUrl: 'export-review-action.component.html',
  styleUrls: ['contextual-action.component.scss'],
})
export class ExportReviewActionComponent extends ContextualActionComponent {

  onCreateExportClick() {
    console.log('Create Export: ', this.selectedRows);
  }

  onReviewClick() {
    console.log('Reivew: ', this.selectedRows);
  }

}
